export default __webpack_public_path__ + "static/media/LogoPUC.36ce6d02.svg";